import DraftCampaignPartial from "../../partials/campaign/draft-campaign.partial";

export default function DraftCampaignScreen() {
  return <DraftCampaignPartial />;
}
